<template>
  <div id="contenedor-principal-consultadecatalogodefirmantes" style="position:relative;">
    <div id="contenedor-encabezados-consultadecatalogodefirmantes" class="text-left">
      <h1>Consulta del catálogo de firmantes</h1>
      
    </div>
    <div id="contenedor-principal-consultadecatalogodefirmantes" class="row mt-3">
      <!-- Filtro de Búsqueda -->
      <transition name="fade">
      
      <div v-show="(!mostrarFormularioVisualizarProcesado)"  id="contenedor-filtros-consultadecatalogodefirmantes" class="col-12 col-sm-12 col-md-12 col-lg-4 col-xlg-4">
      <div v-bind:class="[(mostrarFormularioVisualizarProcesado)   ? 'wrapDivBloqueado': '']">
       <div v-bind:class="[(mostrarFormularioVisualizarProcesado)  ? 'area_verde bloquearDiv': 'area_verde']">


        
        <div >
       
            <FiltroReportesCatalogoDeFirmantes 
                :catalogos="catalogos" 
                :elementosAOmitir ="elementosAOmitir"
                :elementosAConservar ="elementosAConservar"
                :key="'filtro'+contrenderfiltrosreportes"
                :AccionesMostrar="comportamientoFiltroDeBusquedaProcesados"
                :ejecutalimpiarTablaResultados="limpiarTablaResultados" 
                :ejecutaLaFuncion="buscarProcesadoAPI"
                :area="obtenerAreaDeUsuario"
                :tituloDeBusqueda="'Búsqueda del procesado'"              
                :ref="'filtroBusqueda'">
            </FiltroReportesCatalogoDeFirmantes>
      
          </div>
        </div>
      
        </div>             
      </div>
      </transition>
      <!-- Tabla de resultados  -->
      <div v-bind:class="[(mostrarFormularioVisualizarProcesado) ? 'col-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12':'col-12 col-sm-12 col-md-12 col-lg-8 col-xlg-8  pt-sm-4 pt-md-4 pt-lg-0 pt-xlg-0']" id="ProcesadosEncontrados_div">
        <div class="area_verde">
          <transition name="fade">


          <div v-if="(procesados == undefined || procesados == null || procesados.length <= 0) &&(!mostrarFormularioVisualizarProcesado)" style="background-color:var(--gris-pj); padding: 8px;">

            <div class="d-flex justify-content-center">
              <i class="fas fa-search mr-sm-2" style="font-size: 25px;"></i>
              <div class="align-content-center">
                <h5>Consulta del catálogo de firmantes a encontrar</h5>
                <!-- Esto es lo que se muestra antes de la busqueda -->
              </div>
            </div>
          </div>
          <TablaDeResultadosFirmas 
            v-else-if="procesados != undefined && procesados != null"
            v-show="(!mostrarFormularioVisualizarProcesado)"
            v-on:valorParaElPadreAccion="accionRealizar"
            :AccionesMostrar="accionesdelaTablaDeResultadosProcesados"
            :TablaReporteDeCatalogoDeFirmantes="procesados"
            v-on:restablecervalores="restablecerValoresDespuesDeGuardarOEliminar"
            >
          </TablaDeResultadosFirmas>
          </transition>



          <transition name="fade">
          <VisualizarProcesado 
            v-if="mostrarFormularioVisualizarProcesado"          
            :VisualizarProcesados="Procesado"
            :tituloDeInformacion="'Información del procesado'"
            :AccionesMostrar="comportamientoVisualizarProcesados"
            v-on:restablecervalores="restablecerValoresDespuesDeGuardarOEliminar"
            v-on:botoncancelar2="restablecerVistaProcesados"
            :ref="'informacionVisualizarProcesado'">
          </VisualizarProcesado>
          </transition>
          

        </div>


        



      </div> 




    </div>
    
  </div>
</template>

<script>
import TablaDeResultadosFirmas from '@/components/SIVAC/Comun/TablaDeResultadosFirmas'
import FiltroReportesCatalogoDeFirmantes from '@/components/SIVAC/Comun/FiltroReportesCatalogoDeFirmantes'
import VisualizarProcesado from '@/components/SIVAC/Firmas/VisualizarProcesado'
import enumeraciones from '@/../static/js/enumeraciones'
import comun from "@/../static/js/comun"
import api from '@/../static/js/api'
import axios from 'axios'
export default {
    components: {
      FiltroReportesCatalogoDeFirmantes,
      TablaDeResultadosFirmas,
      VisualizarProcesado
    },
    
    data(){
      return{
          enumeraciones,
          mostrarFormularioVisualizarProcesado:false,

          accionesdelaTablaDeResultadosProcesados:{
          alta: false,
          baja: false,
          cambios: false,
          visualizacion: true,
          reportes: false,
          consulta: true,
          mostrartituloreporte: false,
          mostrardelitos: false,
        },

        comportamientoFiltroDeBusquedaProcesados:{            
          administracion: true,
          consulta: false,
          mostrardelitos: true,
        },

        comportamientoVisualizarProcesados :{

          mostrardelitos: true
        },
          
        catalogos: [
          { catalogoId: enumeraciones.catalogos.EstatusProcesado, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_EstatusDelito' },          
          { catalogoId: enumeraciones.catalogos.PartidosJudiciales, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_PartidoJudicial' },
          { catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Area' },
          { catalogoId: enumeraciones.catalogos.Materias, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Materia' },
          { catalogoId: enumeraciones.catalogos.TiposDeDocumentos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_TipoDocumento' },
          { catalogoId: enumeraciones.catalogos.Consecutivo, idDelInput: 'filtroDeBusqueda_Consecutivo_Firmas' },          
          { catalogoId: enumeraciones.catalogos.NumeroExtra, idDelInput: 'filtroDeBusqueda_NoExtra_Firmas' },
          { catalogoId: enumeraciones.catalogos.Delitos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Delito' }

        ],
        elementosAOmitir: {
          //materias: [5,10] //áreas de Majat
        },
        procesados: null,
        Procesado: null,

        elementosAConservar: {


          tiposDocumento: [1,5,23,27],
           areas: [12,95,54],
           partidosJudiciales: [1],
           materias: [6,9],
           entidades: [1],


        },

        contrenderfiltrosreportes: 0,


         actualizoarea: false,


      }
    },


    computed:{

        //  elementosAConservar : function()
        // {
        // let ep = {  
        //    tiposDocumento: [1,5],
        //    areas: [12,95],
        //    partidosJudiciales: [1],
        //    materias: [6],
        //    entidades: [1],
           
        //   }

        // //console.log(ep);


        // return ep;

        //  },


      /**
       * Funcion encargadas de obtener area del usuario de store.
       */
      obtenerAreaDeUsuario() {

          
        return this.$store.getters.Get_AreaDelUsuario;




      }



       },


       watch: {
        '$store.getters.Get_AreaDelUsuario': function() {
            
            //console.log("entro en watch", this.$store.getters.Get_AreaDelUsuario);


            if(!this.actualizoarea){

              if((this.$store.getters.Get_AreaDelUsuario==null || this.$store.getters.Get_AreaDelUsuario==undefined) || (this.$store.getters.Get_AreaDelUsuario.AreaId==112) ||  (this.$store.getters.Get_AreaDelUsuario.AreaId==1)){


               // this.elementosAConservar= null;
                
                this.actualizoarea= true;

                

              }

              this.contrenderfiltrosreportes++;




            }
        }
    },



    methods: {
    /** 
     * Metodo encargado de llamar API para búscar Procesados en base a los datos proporcionados.
     */
      buscarProcesadoAPI:function() 
      { 
        const parametros = 
        {    
          PartidoJudicialId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_PartidoJudicial.partidoJudicialId) ? this.$refs['filtroBusqueda'].parametros_PartidoJudicial.partidoJudicialId : null,
          MateriaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Materia.materiaId) ? this.$refs['filtroBusqueda'].parametros_Materia.materiaId : null,
          AreaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Area.areaId) ? this.$refs['filtroBusqueda'].parametros_Area.areaId : null,
          TipoDeDocumentoId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_TipoDocumento.tipoDocumentoId) ? this.$refs['filtroBusqueda'].parametros_TipoDocumento.tipoDocumentoId : null,
          Consecutivo: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].consecutivo) ? this.$refs['filtroBusqueda'].consecutivo : null,          
          NumeroDeDocumento: this.$store.state.Comun_NumeroExtra,
          NumeroRomano: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].numeroRomano) ? this.$refs['filtroBusqueda'].numeroRomano : null,         
          DelitoId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Delito.delitoId) ? this.$refs['filtroBusqueda'].parametros_Delito.delitoId : null,                             
          EsPrueba: this.enumeraciones.EsPrueba,
          
          Nombre:  this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].nombre) ? this.$refs['filtroBusqueda'].nombre : null,
          ApellidoPaterno: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].apellido_paterno) ? this.$refs['filtroBusqueda'].apellido_paterno : null,
          ApellidoMaterno: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].apellido_materno) ? this.$refs['filtroBusqueda'].apellido_materno : null,
          ClaveDelProcesado: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].clave_del_procesado) ? this.$refs['filtroBusqueda'].clave_del_procesado : null,
          ClaveDelProcesado_Anterior: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].clave_del_procesado_anterior) ? this.$refs['filtroBusqueda'].clave_del_procesado_anterior : null,
          TipoEstatusProcesadoId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_TipoEstatusProcesado.tipoEstatusProcesadoId) ? this.$refs['filtroBusqueda'].parametros_TipoEstatusProcesado.tipoEstatusProcesadoId : null,
          TipoFiltroEjecucionId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].TipoFiltroEjecucionId) ? this.$refs['filtroBusqueda'].TipoFiltroEjecucionId : null,
          TipoFiltroSegundoPenalId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].TipoFiltroSegundoPenalId) ? this.$refs['filtroBusqueda'].TipoFiltroSegundoPenalId : null

        }
        if(this.validarDatosBusquedaProcesado(parametros))
        {
          comun.SeEstaCargandoInformacion(true); 
          const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        

          axios.post(api.conexion + api.SIVAC.sistema.consultas.firmas.BuscarFirmantes, parametros, headerPeticion)
          .then(respuesta => {
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              this.limpiarTablaResultados();
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              //Cargar Datos de Procesados
              this.procesados = respuesta.data.Procesados;
              this.$nextTick(()=> { PaginarTabla('tablaDeProcesados_ReporteDeCatalogoDeFirmantesPaginacion_table', 10)});
              // comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);

              
            }         
          })
          .catch(e => {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
        }
      },
      validarDatosBusquedaProcesado: function(datos)
      {
        if((datos.PartidoJudicialId == null || datos.PartidoJudicialId == -1) &&    
            (datos.AreaId == null || datos.AreaId == -1) && 
            (datos.MateriaId == null || datos.MateriaId == -1) &&
            (datos.TipoDeDocumentoId == null || datos.TipoDeDocumentoId == -1) && 
            (datos.DelitoId == null || datos.DelitoId == -1) &&
           
            (datos.Nombre == null || datos.Nombre == undefined) && 
            (datos.ApellidoPaterno == null || datos.ApellidoPaterno == undefined) && 
            (datos.ApellidoMaterno == null || datos.ApellidoMaterno == undefined) &&
            (datos.ClaveDelProcesado == null || datos.ClaveDelProcesado == undefined)
        )
        {          
            comun.mensajeDeAlerta("Favor de llenar por lo menos un campo del formulario.", null, null);
            return false;
        }
        return true;
       },
       /** 
       * Metodo encargado de verificar que el campo proporcionado tenga un valor valido
       * @param {string/int/other} campo [campo]
       */
      campoRequeridoEsValido: function(campo) 
      {
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },
       /** 
       * Metodo encargado de limpiar los valores de la tabla de resultados.
       */
      limpiarTablaResultados: function()
      {
        this.procesados = null;
      }, 


      /** 
       * Metodo encargado de limpiar los valores de Procesado.
       */
      limpiarValores: function()
      {
        this.Procesado = null;
        
      },

      /** 
       * Metodo encargado de habilitar los componentes de acuerdo a la acción seleccionada (alta, baja, cambios, visualizar)
       * en la tabla de resultados, además de proporcionar el procesado correspondiente a esa acción.
       * @param {object} datos [datos: Procesado,Accion{Alta, Baja, Cambios, Visualizar}]
       */
      accionRealizar:function(datos)
      {
        this.limpiarValores();
        //Asignar un id para mostrar los valores en una vista
        this.Procesado = Object.assign({}, datos.Procesado);
        



        //Visualizar loa datos del procesado
        if(datos.Accion.Visualizar) 
        {
          this.visualizarProcesado();
        }

      },



      /**
         * Función encargada de restablecer los valores de la pantalla
         */
      restablecerValoresDespuesDeGuardarOEliminar()
      {

        
        this.mostrarFormularioVisualizarProcesado= false;
        this.limpiarValores();
        this.limpiarTablaResultados();
        // this.buscarProcesadoAPI();

      },


      restablecerVistaProcesados()
      {

        
        this.mostrarFormularioVisualizarProcesado= false;
       

      },


      


      visualizarProcesado:function()
      {
       
       this.mostrarFormularioVisualizarProcesado= true;
      
      },


     }
    }

</script>

<style scoped>
  .bloquearDiv{
    pointer-events: none;
  }
  .wrapDivBloqueado
  {
    opacity: 0.7;
    cursor: not-allowed;
  }
  .fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.area_verde{
  background-color: var(--verde-pj);
    box-shadow: 0px 6px 20px 4px #161616;
    padding: 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/SIVAC/Consultas/ConsultaDeCatalogoDeFirmantes.vue